export const B2BEC_OVERVIEWGUIDE_TYPES = {
  MY_MACHINES: 'myMachines',
  MY_ORDERS: 'myOrders',
  PRODUCTS: 'products',
}
